import { PrimaryButton, TertiaryButton } from '../button2';

import { CtaProps } from './types';

const HeroCta: React.FC<CtaProps & { Button: typeof PrimaryButton | typeof TertiaryButton }> = ({
  'aria-describedby': ariaDecribedBy,
  as,
  Button,
  children,
  fullWidth,
  href,
  onClick,
  reversed,
}) => {
  const props = {
    'aria-describedby': ariaDecribedBy,
    fullWidth,
    reversed,
    children,
    onClick,
  };

  // Unfortunately the function signature approach used for the button
  // components doesn't make it possible for us to just generate the right
  // combination of as/href/to props and spread it into the props of a single
  // component. We need to split up the different possibilities into different
  // component instances (createElement calls) to help TypeScript identify which
  // signature was used.
  if (href) {
    if (as && typeof as !== 'string') {
      return <Button {...props} to={href} as={as} />;
    }

    return <Button {...props} href={href} as="a" />;
  }

  return <Button {...props} />;
};

export const HeroPrimaryCta: React.FC<CtaProps> = (props) => {
  return <HeroCta {...props} Button={PrimaryButton} />;
};

export const HeroComplementaryCta: React.FC<CtaProps> = (props) => {
  return <HeroCta {...props} Button={TertiaryButton} />;
};
